class CelebrityScroll {
  constructor(section) {
    this.section = section;
    this.track = section.querySelector('.celebrity-scroll-track');
    this.speed = section.dataset.speed || 40;
    this.direction = section.dataset.direction || 'left';
    
    this.init();
  }

  init() {
    // Preload all images before starting animation
    this.preloadImages().then(() => {
      // Set animation duration based on speed setting
      this.track.style.animationDuration = `${this.speed}s`;
    });
    
    // Handle visibility change to optimize performance
    this.handleVisibilityChange();
  }

  preloadImages() {
    return new Promise((resolve) => {
      const images = this.track.querySelectorAll('img');
      let loadedCount = 0;
      
      if (images.length === 0) {
        resolve();
        return;
      }
      
      images.forEach(img => {
        if (img.complete) {
          loadedCount++;
          if (loadedCount === images.length) {
            resolve();
          }
        } else {
          img.addEventListener('load', () => {
            loadedCount++;
            if (loadedCount === images.length) {
              resolve();
            }
          });
          img.addEventListener('error', () => {
            loadedCount++;
            if (loadedCount === images.length) {
              resolve();
            }
          });
        }
      });
    });
  }

  handleVisibilityChange() {
    // Pause animation when page is not visible to save resources
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.track.style.animationPlayState = 'paused';
      } else {
        this.track.style.animationPlayState = 'running';
      }
    });
  }

  // Method to update speed dynamically (if needed)
  updateSpeed(newSpeed) {
    this.speed = newSpeed;
    this.track.style.animationDuration = `${this.speed}s`;
  }

  // Method to change direction dynamically (if needed)
  updateDirection(newDirection) {
    this.direction = newDirection;
    this.section.dataset.direction = newDirection;
  }
}

// Initialize all celebrity scroll sections on page
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.celebrity-scroll-section');
  sections.forEach(section => {
    new CelebrityScroll(section);
  });
});

// Reinitialize on Shopify section events (for theme editor)
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.celebrity-scroll-section');
    if (section) {
      new CelebrityScroll(section);
    }
  });
  
  document.addEventListener('shopify:section:reorder', () => {
    const sections = document.querySelectorAll('.celebrity-scroll-section');
    sections.forEach(section => {
      new CelebrityScroll(section);
    });
  });
}
